module.exports = __webpack_public_path__ + "img/vpticon1.46aed76d.png";